import React from 'react';
import '../styles/MainContent.css';

const MainContent = () => {
  return (
    <div className="main-content">
      <div className="content-header">
        <h2>Overview</h2>
      </div>
      <div className="cards-container">
        <div className="card">
          <div className="card-icon">📊</div>
          <div className="card-info">
            <h3>Total Users</h3>
            <p className="card-value">1,234</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon">💰</div>
          <div className="card-info">
            <h3>Revenue</h3>
            <p className="card-value">$45,678</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon">📈</div>
          <div className="card-info">
            <h3>Growth</h3>
            <p className="card-value">+12.5%</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon">🎯</div>
          <div className="card-info">
            <h3>Active</h3>
            <p className="card-value">567</p>
          </div>
        </div>
      </div>
      <div className="content-section">
        <h3>Recent Activity</h3>
        <div className="activity-list">
          <div className="activity-item">
            <span className="activity-icon">✓</span>
            <div className="activity-details">
              <strong>User registration</strong>
              <p>New user signed up</p>
            </div>
            <span className="activity-time">2 hours ago</span>
          </div>
          <div className="activity-item">
            <span className="activity-icon">✓</span>
            <div className="activity-details">
              <strong>System update</strong>
              <p>System backup completed</p>
            </div>
            <span className="activity-time">5 hours ago</span>
          </div>
          <div className="activity-item">
            <span className="activity-icon">✓</span>
            <div className="activity-details">
              <strong>Payment received</strong>
              <p>New payment processed</p>
            </div>
            <span className="activity-time">1 day ago</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;

